<template>
	<svg xmlns="http://www.w3.org/2000/svg" @click="clicked" v-if="active" id="active" fill="none" viewBox="-4 -4 38 37" width="25" height="25">
		<rect fill="black" x="-4" y="-4" width="38" height="37" rx="6.46" />
		<rect fill="black" x="-3" y="-3" width="36" height="35" rx="6.46" />
		<path
			d="M26.8515 13.5409C26.8515 20.7386 20.9572 26.5819 13.6758 26.5819C6.39431 26.5819 0.5 20.7386 0.5 13.5409C0.5 6.34329 6.39431 0.5 13.6758 0.5C20.9572 0.5 26.8515 6.34329 26.8515 13.5409Z"
			stroke="white"
		/>
		<path d="M33.0003 32.0837L23.6611 22.6701" stroke="white" stroke-linecap="round" />
		<path d="M13.6752 5.29861L6.54004 8.83103V17.8583L13.6752 21.3907L20.8104 17.8583V8.83103L13.6752 5.29861Z" stroke="white" stroke-linejoin="round" />
		<path d="M6.54004 8.83096L13.6752 12.3634L20.8104 8.83096" stroke="white" />
		<path d="M13.6758 12.3616V21.3889" stroke="white" />
	</svg>
	<svg xmlns="http://www.w3.org/2000/svg" @click="clicked" v-else id="inactive" fill="none" viewBox="-4 -4 38 37" width="25" height="25">
		<rect fill="black" x="-4" y="-4" width="38" height="37" rx="6.46" />
		<rect fill="white" x="-3" y="-3" width="36" height="35" rx="6.46" />
		<path
			d="M26.8515 13.5409C26.8515 20.7386 20.9572 26.5819 13.6758 26.5819C6.39431 26.5819 0.5 20.7386 0.5 13.5409C0.5 6.34329 6.39431 0.5 13.6758 0.5C20.9572 0.5 26.8515 6.34329 26.8515 13.5409Z"
			stroke="black"
		/>
		<path d="M33.0003 32.0837L23.6611 22.6701" stroke="black" stroke-linecap="round" />
		<path d="M13.6752 5.29861L6.54004 8.83103V17.8583L13.6752 21.3907L20.8104 17.8583V8.83103L13.6752 5.29861Z" stroke="black" stroke-linejoin="round" />
		<path d="M6.54004 8.83096L13.6752 12.3634L20.8104 8.83096" stroke="black" />
		<path d="M13.6758 12.3616V21.3889" stroke="black" />
	</svg>
</template>

<script>
	export default {
		name: 'MagnifierSVG',
		props: {
			active: Boolean
		},
		methods: {
			clicked() {
				this.$emit('click');
			}
		}
	};
</script>

<style scoped lang="scss">
	#active {
		.cls-1 {
			fill: #231e21;
		}
		.cls-2 {
			fill: none;
			stroke: #231e21;
			stroke-miterlimit: 10;
			stroke-width: 40px;
		}
	}
	#inactive {
		.cls-1 {
			fill: #231e21;
			stroke: #231e21;
			stroke-miterlimit: 10;
			stroke-width: 40px;
		}
		.cls-2 {
			fill: #fff;
		}
	}
</style>
